import { Api, ApiRequest, ResType, ParameterType } from '@api'
import { Logger } from '@utils'

export const addUsers = async ({
	params = {},
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/users'
		const req = new ApiRequest({
			method: 'post',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
			isRequiredToken: false,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const getUsers = async ({
	params = {},
	body = {},
	query = {
		includingDeletedUsersYn: '', // 0: no, 1: yes
	},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/users'
		const req = new ApiRequest({
			method: 'get',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const updateUserPassword = async ({
	params = { id: '' },
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = `/users/${params.id}/password`
		const req = new ApiRequest({
			method: 'put',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
	}
}

export const updateUserProfileImage = async ({
	params = { id: '' },
	body = {},
	query = {},
	customHeaders = {},
	files = [],
}: ParameterType & {
	params: { id: string }
	files: File[]
}): Promise<ResType | undefined> => {
	try {
		const formBody = Api.createFormData(body, files)
		const uri = `/users/${params.id}/profile-image`
		const req = new ApiRequest({
			method: 'put',
			uri: uri,
			body: formBody,
			query: query,
			customHeaders: {
				...customHeaders,
				'Content-Type': 'multipart/form-data',
			},
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
	}
}

export const batchUpdateUsers = async ({
	params = {},
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/users/batch-update'
		const req = new ApiRequest({
			method: 'put',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
	}
}

const usersApi = {
	addUsers: addUsers,
	getUsers: getUsers,
	updateUserPassword: updateUserPassword,
	updateUserProfileImage: updateUserProfileImage,
	batchUpdateUsers: batchUpdateUsers,
}

export default usersApi
